module.exports = __webpack_public_path__ + "static/media/pudge.ffa3ea30.png";